import { AfterViewInit, Component, ElementRef, Input, OnDestroy, OnInit, TemplateRef, ViewChild } from '@angular/core';
import intlTelInput, { Iti } from 'intl-tel-input';
import { BaseInputFieldComponent } from '../base/base-input-field.component';
import { InputDisplay } from '../input-group/input-group.properties';
import { InputFieldType } from '../input-field/input-field.properties';

@Component({
  selector: 'shared-ui-inputs-phone-input',
  templateUrl: './phone-input.component.html',
  styleUrls: ['./phone-input.component.css'],
  standalone: false,
})
export class PhoneInputComponent extends BaseInputFieldComponent implements OnInit, AfterViewInit, OnDestroy {
  @Input() separateDialCode = true;
  @Input() formatOnDisplay = true;
  @Input() formatAsYouType = true;
  @Input() nationalMode = true;
  @Input() countrySearch = true;
  @Input() strictMode = true;
  @Input() display = InputDisplay.Block;
  @Input() prependElements: TemplateRef<unknown>[] = [];
  @Input() appendElements: TemplateRef<unknown>[] = [];
  @ViewChild('phoneInput') inputRef?: ElementRef;
  InputFieldType = InputFieldType;
  iti: Iti | null = null;

  constructor() {
    super();
  }

  ngOnInit(): void {}

  ngAfterViewInit(): void {
    this.initializeIntlTelInput();
  }

  ngOnDestroy(): void {
    this.iti?.destroy();
  }

  getNumber(): string | null {
    return this.iti?.getNumber() ?? null;
  }

  isNumberValid(): boolean {
    return this.iti?.isValidNumberPrecise() ?? false;
  }

  initializeIntlTelInput(): void {
    const input = this.inputRef?.nativeElement;
    if (input) {
      this.iti = intlTelInput(input, {
        initialCountry: 'us',
        separateDialCode: this.separateDialCode,
        strictMode: this.strictMode,
        formatOnDisplay: this.formatOnDisplay,
        formatAsYouType: this.formatAsYouType,
        nationalMode: this.nationalMode,
        utilsScript: './assets/scripts/utils.js',
      });
    }
  }
}
